
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as labsEugWPpG3bg1pWm0N__45oZ4EFHurzS0V_45EBLqQNgddNnYMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/labs.vue?macro=true";
import { default as colabLlnvnUwkvwZETJIHQ4QfIVZyeZZzx9R8tRYQ1ZqyvsoMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/colab.vue?macro=true";
import { default as errorHEBFjkuVEm3egRTYlOGQaYp5XWzj9OQ9gxnw35NcmpUMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/error.vue?macro=true";
import { default as indexRuDysWsHcBR_45FLk2JxOa2bUP1Sk1dotaYaji8FR9BlgMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/index.vue?macro=true";
import { default as indexczxs5RTmgAlNdFVDc7MD4g6d4k49Nsc55Yha924YvokMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/launch/index.vue?macro=true";
import { default as indexceC4BEfxLp4oYi67wQ6LJAiktD7inz8ncQYn9CndaNcMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/launch/status/index.vue?macro=true";
import { default as quick_45launch_45statusUPgBLLXVf1nemuqQ_5BSVOP_YKMldCcZWMN4R5uyS9sMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/launch/quick-launch-status.vue?macro=true";
import { default as launchUdjRW6mREdXdkCOHEcCwwrAN2AcLTGqQqK9aK5NZqH4Meta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/launch.vue?macro=true";
import { default as indexJW6laWd_45TcMYy_EsHO1_zII6lqLJWrCsvxO1DrMdsf8Meta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/manage/index.vue?macro=true";
import { default as _91manageType_93ss_45CZiqF1kyDqyMfV2AliprzvwX37uoUmZLvUc5KLlgMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/manage/[manageType].vue?macro=true";
import { default as indexV4lIMvydjrtmrNVc9hUMGYJ4qGaHL3nHkAdnJUJs234Meta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/manage/create/index.vue?macro=true";
import { default as managejqn3l_45rG_457agqgMDe9uInR_45P9KNLrfbLZ74pjcVGoRcMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/manage.vue?macro=true";
import { default as statusZzIokv6Bv5CNF8yR9xzPadsayWxfjl4ZPSVbr0q8ARYMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/status.vue?macro=true";
import { default as api_45doc52suc_45uZXFNbo2XJAYCWoTpdLFjnEXBrgJ1bY0tY_45zMMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/api-doc.vue?macro=true";
import { default as index4IAtG0DzQLmb6PbgeLLieh2XcY_45vhmnBfOJZRE89_dgMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/welcome/index.vue?macro=true";
import { default as welcome4iKnzdMOtx4C3K3lVkvHPVtUMwRrLGAMe8fNJM03DU8Meta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/welcome.vue?macro=true";
import { default as bulk_45editjNk6rjl1dvq2HaHmqD8NBS1_457RiiOqTjBnltvnZJbNsMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/bulk-edit.vue?macro=true";
import { default as html5_45adsLEDFVmCy4zGrF3NXnRszPFicAOotSe5PxKMusiMzFaYMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/html5-ads.vue?macro=true";
import { default as video_45adsaIA_45I7b4ZgCvv3T5jFedVk7wLAhWY7m2qngCPjKHh7AMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/video-ads.vue?macro=true";
import { default as indexJBaaBrlj4luIkYk__45fF6I_45EDSbln4DFW6RQJhwUz2C4Meta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/bulk/index.vue?macro=true";
import { default as deckHelperOvuDK2nxQCQ14YN00MDnZiNl0oEpq6MNBgXtFpdMgpAMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/deckHelper.vue?macro=true";
import { default as index5LgU_45IYe9Ep4ggY9_nw2t4b2WlfdeGvMF4ftUS2U53sMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/login/index.vue?macro=true";
import { default as office_45matex_45gnlmYLAFpJbyUtv4DjWfwWPBYVRByaoLDagrDip0IMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/office-mate.vue?macro=true";
import { default as indexuKcnpEkaSLiq6s51dKaMRTcW54xDL0_QKCZV2cfTQScMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/setup/index.vue?macro=true";
import { default as indexse7hLuvxT8SV97aFVek_45i_45nJZJgHrYKdSILspxaChsgMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/style/index.vue?macro=true";
import { default as indexZITY8hJylUEXbiCiOyGLOw0ttQdAsrhtdV2rOp_4mZ4Meta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/alerts/index.vue?macro=true";
import { default as indexk6SrTCT_lDNs8kqrl3CZe44doPThsK0kUGcDp0q51tYMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/bionic/index.vue?macro=true";
import { default as receiptusjQnt6KmytjgocUUrLI_0N_45Gk_2ApxqFMBlXcMBkzcMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/bulk/receipt.vue?macro=true";
import { default as form_45designeru_45PDvYeAhvlBYsXu1Llk1pr6Ee3V7DZvYCyPgPYc8rIMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/form-designer.vue?macro=true";
import { default as logspbxOxvfGTHc5VJI6ysSTq3YFB9ZjZhq_45tSMdUSWhXzYMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/insights/logs.vue?macro=true";
import { default as logoTfrnqn6SlY8KHpkNyd0PuDes_45d0ygbehiEbLruLWkV8Meta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/internal/logo.vue?macro=true";
import { default as vue3LQqHpak9sIjxz9hsr2QPO7XENlT6NK7Cp_kYWhdVO5EMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/internal/vue3.vue?macro=true";
import { default as datagFXia2sVlDggqC9Is_Tlrp_45_45uwcCL_Szy43e6rNpERAMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/settings/data.vue?macro=true";
import { default as bionic2NCOASl6o1u2_45T9WdxLzxzH_45j6hc9S1y_45OryqFA45EFcMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/bionic/bionic2.vue?macro=true";
import { default as bionic3_45iLT_Uv2vBHE5KyzHiSg_PTb1pwj6DfkVczlNA6B5_45sMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/bionic/bionic3.vue?macro=true";
import { default as bionic4u3w4vZtMWOfUsLnqxUOeZK3JZaCTPjDJ_yrsoy52bIEMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/bionic/bionic4.vue?macro=true";
import { default as indexnZTTOJBpxpwcXrYA_aab7sSwQN0zUXIUDkxRBN2Q6eMMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/internal/index.vue?macro=true";
import { default as page_45not_45found2UgGANw1W7L5GcdmT_454FjTgv7rtJTLwZieV056bBDQAMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/page-not-found.vue?macro=true";
import { default as indexVj1sxgnQ5wWVm1sBC5qXFOyoibmMm_6R7X_g_qH4AV8Meta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/approvals/index.vue?macro=true";
import { default as indexpBM_rXbbZxpQFC5D1mDddC8PEUBrHgVD0WIWJFRqnz4Meta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/dashboard/index.vue?macro=true";
import { default as index7Ck5tdmLAOsxosdWirYYdCbuvbBvWFb6S4N6e0jJQ98Meta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/reporting/index.vue?macro=true";
import { default as _91partner_93i1BL8MQsWKk4jEjDR_45Y8flv9LuoKCqGLVmvYoBcuTdAMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/setup/[partner].vue?macro=true";
import { default as index_Qq44FRImIbk7qVu6E5CXslSlw8eygxk3yBE9AsFEfEMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/blueprints/index.vue?macro=true";
import { default as crawlergx3gv2TPU70raXJ8_tcDR9R1_45Rycxf6jaCwfCv_45QysgMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/insights/crawler.vue?macro=true";
import { default as ai_45helprXQn7pEt96vmYJWEefyyjKUq9ZqLli2GPRu529g00SQMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/internal/ai-help.vue?macro=true";
import { default as sandboxkFOSF1whqKw97Fe8WcGusw6G03P5ecSRMfb5mD_TEFYMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/internal/sandbox.vue?macro=true";
import { default as fluencyUeSHQ7C_45nhp1EV69AORXAxcjN2amRK_My5JFQE7uC9AMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/settings/fluency.vue?macro=true";
import { default as config5k7MTm2DhepJJPWijX_H5PvRxgi0Fr8cBVsBxtwtgGIMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/blueprints/config.vue?macro=true";
import { default as feedbackEScmuAfO3_45XtUUGz30tWYaO2tLdLAWDuekzZuUGYmFgMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/insights/feedback.vue?macro=true";
import { default as api_45testzXWC_45lfSktGMdkeIJamr_45J0KaN9O70TW6eF4vUyVY3YMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/internal/api-test.vue?macro=true";
import { default as indexTzIY8Hhk99Fwl_S5BvsZzBwjggYUwQtSVibqpANveu4Meta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/prospecting/index.vue?macro=true";
import { default as billingKfyGcAwOsqfBjL7Tdl8kR0BP2go_45QJnZ6AOAUmj8C68Meta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/reporting/billing.vue?macro=true";
import { default as historygvGshY8hcuHaU5jzGojGyjmIM_o7EZgvVzAgwTCjsUYMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/reporting/history.vue?macro=true";
import { default as previewKVGNJl7R7sM4We8Gvtt9T_ru18vLcuulvTxmz5rCBf8Meta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/reporting/preview.vue?macro=true";
import { default as customerY_45Z5p7pr9QZSX13Dxwa0qs388yJoZqvw8kVPT6j7EpgMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/settings/customer.vue?macro=true";
import { default as broadcast5bwkzwOrzTZVCm82OOoKxAWrepyLuQS_eRAbVTvHzDgMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/customer/broadcast.vue?macro=true";
import { default as prime_45vue01VszST1saDjxAglLNBUWuspugQl7pbGwpFHAYzEESMMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/internal/prime-vue.vue?macro=true";
import { default as crawlerDataQpRezcLcHebVggbTBz6Bkub41LPMlS0QHEdnvmr4mrUMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/account/crawlerData.vue?macro=true";
import { default as adRendererUgpUUvuI1360UhQq1rfnbhpqpqvAmIitG6K9r_45VfP3gMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/internal/adRenderer.vue?macro=true";
import { default as colab_45test8hokwVP1nIWCZGFoM7vp45xUtG6nbDlG8f_456aT48btIMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/internal/colab-test.vue?macro=true";
import { default as smoke_45testnWaxeunfYFsdlTEnfSRe7DC23UNu83POr4LEHs0TSVYMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/internal/smoke-test.vue?macro=true";
import { default as chartRenderhh8O21vVQu9SqyQeNe7ixI_45wKGwJXPwk18_45XEn33b8kMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/internal/chartRender.vue?macro=true";
import { default as drag_45n_45dropTn_45eaQra1O2D3OrbbPWHAqfCdDIAC9ajsdLc_oew03IMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/internal/drag-n-drop.vue?macro=true";
import { default as settings_45v2fZVrFOYeqw9rY7dD5Kgfq_tJXDUOuy4c0W_Nctsac_45MMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/internal/settings-v2.vue?macro=true";
import { default as style_45guidepBKBw4AYXVfHKefgfu0OPSaGKXu6JybWcbC9AYAXDiwMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/internal/style-guide.vue?macro=true";
import { default as target_45setssDsyO5gqgTm94j616X5M4W5VQOId5g_45OuBugzS50TS8Meta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/settings/target-sets.vue?macro=true";
import { default as tag_45review0wL0s_TtofjYLFxa1Xlzr_45HCqRvHiGgCzNwO4y975yQMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/blueprints/tag-review.vue?macro=true";
import { default as reverse_45syncDY8aObfJiPRqRQwVqLOnl5IqU7idMGZBPAYk889ry_45gMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/insights/reverse-sync.vue?macro=true";
import { default as dynamic_45form6BWn_45CfaPlZcjQzsMR9FxWBhALfCWQxjxCm6laccyPkMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/internal/dynamic-form.vue?macro=true";
import { default as indexasiMBSknrrQmgth3Q8ocXmZIeB597Zk5OK_45at4rHXLMMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/alerts/anomalies/index.vue?macro=true";
import { default as budget_45groupsqzKkPt9LRm8de1e2i0NArWUA0JheAaRRF3ojv9QsWD4Meta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/insights/budget-groups.vue?macro=true";
import { default as peer_45insightsh52YZ3dE6Yz2j0SMyAcbqBS2L4Lbe7zzCT_WSLGy3RoMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/insights/peer-insights.vue?macro=true";
import { default as colab_45manager4LPbyVbRgvpqZyIdKkNuaEpsmzct6G7hwwAz6Ye3xkQMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/internal/colab-manager.vue?macro=true";
import { default as change_45historynlJ8Z41md04Aeg6PMHN2ODo8SlWiNcMRETqdusKdPE8Meta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/insights/change-history.vue?macro=true";
import { default as blueprint_45demohv3mgdzgmOOn9r3Xcw_45C1UIyf2mmcqzXMLw80LV3iGEMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/internal/blueprint-demo.vue?macro=true";
import { default as dynamic_45reportybO9k1zw9unNOqStnkk1dK2Vr8MSeUdeKDmYeXPbOwEMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/internal/dynamic-report.vue?macro=true";
import { default as layout_45builderQi5tpg7ewFxmuizJ1jjrZ3vpUUch36aYxH9i3wsVMBUMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/internal/layout-builder.vue?macro=true";
import { default as data_45exploreryl8Mw3jJqB2gS6zUdRSgQJfxlBxjE_455zmvzU_rZsabAMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/reporting/data-explorer.vue?macro=true";
import { default as account_45ingest7SMLKFC9WVNNwr4DHRlDJSPwb87Gx_45_F419XTPZ_45lmwMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/settings/account-ingest.vue?macro=true";
import { default as example_45widgetIruyw_9MEjMomi7e0EJUEZo_45WFLUVa_0c25iSXzPAx0Meta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/dashboard/example-widget.vue?macro=true";
import { default as index0qxYtMYUZserJT1fefH0SuS6WXs5ROWpEeUF5G_45V8TMMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/internal/customers/index.vue?macro=true";
import { default as shared_45audiencesSA2adHKrNnnSVHOFwx9WwuQppvugpEW1VkA4_hMeyD0Meta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/settings/shared-audiences.vue?macro=true";
import { default as analyst_45scorecardZ_45ZANQVo1B3paQa3P7hWv8o_dmworD_saGhNuZJVccMMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/insights/analyst-scorecard.vue?macro=true";
import { default as engineeringAuditProjectSummaryBdW_6LThQpAgXD6g4XocEhgSf5VDluRqhD8cgE0vIi0Meta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/internal/engineering-audit/engineeringAuditProjectSummary.vue?macro=true";
import { default as engineeringAuditCustomerBreakdownmga21olmwd_bB_456eWWgkZOS78N33I0ZZt4sa_45YsIEwsMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/internal/engineering-audit/engineeringAuditCustomerBreakdown.vue?macro=true";
import { default as engineering_45auditNe8Vm3sU_45RusJgNMp_sx8DB6kdNtERQ8L5EEMu7gs4QMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/internal/engineering-audit.vue?macro=true";
import { default as crawlSiteDetectorJ24mnjOHLj1Mbz7GFbQzTDY4PFQQBpOwgdLJ88kUGzsMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/settings/crawlSiteDetector.vue?macro=true";
import { default as crawlerDebugBrowserjy6M_45ISjUQDUuBkshVZhYGgj_45pisaxA2dDHRGb1iSHgMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/account/crawlerDebugBrowser.vue?macro=true";
import { default as budget_45adjustmentsMOWQftunyBZpZqm07htq7TvVTZH2rA_izIJ8WOnVTb0Meta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/insights/budget-adjustments.vue?macro=true";
import { default as account_45performance7m_xETq2kMkCsS2fhV2u80Q8LnnbFN3BNEIbOzwYZNMMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/insights/account-performance.vue?macro=true";
import { default as partner_45sync_45statusJFGifAio_WhjGp0tFK4BB_457D0jFcjNuphTtvi8OHO_MMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/insights/partner-sync-status.vue?macro=true";
import { default as blueprint_45tag_45languageqL5ApWnwGGzUPZD_45wPGoZm6z5dEYLkhgor7KtxSfbmsMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/internal/blueprint-tag-language.vue?macro=true";
import { default as keyword_45recommendationsFklEQyxbCurZfsxMFo7kP5NyLYWmhCrG9_1cDLFZZw0Meta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/insights/keyword-recommendations.vue?macro=true";
import { default as customerPackageSelector_45iStSisulTuJNLa1Vb_456G4L4_45si5UhDEFqRPlWZJCTYMeta } from "/home/production/git/fluent-ui/apps/backpack/src/pages/settings/customerPackageSelector.vue?macro=true";
import { default as component_45stub6MOtWOnrm951L4QaSPbSZthkl00hz7jYr6s9QFjblg4Meta } from "/home/production/git/fluent-ui/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub6MOtWOnrm951L4QaSPbSZthkl00hz7jYr6s9QFjblg4 } from "/home/production/git/fluent-ui/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "labs",
    path: "/labs",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/labs.vue")
  },
  {
    name: "colab",
    path: "/colab",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/colab.vue")
  },
  {
    name: "error",
    path: "/error",
    meta: errorHEBFjkuVEm3egRTYlOGQaYp5XWzj9OQ9gxnw35NcmpUMeta || {},
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/error.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/index.vue")
  },
  {
    name: launchUdjRW6mREdXdkCOHEcCwwrAN2AcLTGqQqK9aK5NZqH4Meta?.name,
    path: "/launch",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/launch.vue"),
    children: [
  {
    name: "launch",
    path: "",
    meta: indexczxs5RTmgAlNdFVDc7MD4g6d4k49Nsc55Yha924YvokMeta || {},
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/launch/index.vue")
  },
  {
    name: "launch-status",
    path: "status",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/launch/status/index.vue")
  },
  {
    name: "launch-quick-launch-status",
    path: "quick-launch-status",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/launch/quick-launch-status.vue")
  }
]
  },
  {
    name: managejqn3l_45rG_457agqgMDe9uInR_45P9KNLrfbLZ74pjcVGoRcMeta?.name,
    path: "/manage",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/manage.vue"),
    children: [
  {
    name: "manage",
    path: "",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/manage/index.vue")
  },
  {
    name: "manage-manageType",
    path: ":manageType()",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/manage/[manageType].vue")
  },
  {
    name: "manage-create",
    path: "create",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/manage/create/index.vue")
  }
]
  },
  {
    name: "status",
    path: "/status",
    meta: statusZzIokv6Bv5CNF8yR9xzPadsayWxfjl4ZPSVbr0q8ARYMeta || {},
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/status.vue")
  },
  {
    name: "api-doc",
    path: "/api-doc",
    meta: api_45doc52suc_45uZXFNbo2XJAYCWoTpdLFjnEXBrgJ1bY0tY_45zMMeta || {},
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/api-doc.vue")
  },
  {
    name: welcome4iKnzdMOtx4C3K3lVkvHPVtUMwRrLGAMe8fNJM03DU8Meta?.name,
    path: "/welcome",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/welcome.vue"),
    children: [
  {
    name: "welcome",
    path: "",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/welcome/index.vue")
  }
]
  },
  {
    name: "bulk-edit",
    path: "/bulk-edit",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/bulk-edit.vue")
  },
  {
    name: "html5-ads",
    path: "/html5-ads",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/html5-ads.vue")
  },
  {
    name: "video-ads",
    path: "/video-ads",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/video-ads.vue")
  },
  {
    name: "bulk",
    path: "/bulk",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/bulk/index.vue")
  },
  {
    name: "deckHelper",
    path: "/deckHelper",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/deckHelper.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: index5LgU_45IYe9Ep4ggY9_nw2t4b2WlfdeGvMF4ftUS2U53sMeta || {},
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/login/index.vue")
  },
  {
    name: "office-mate",
    path: "/office-mate",
    meta: office_45matex_45gnlmYLAFpJbyUtv4DjWfwWPBYVRByaoLDagrDip0IMeta || {},
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/office-mate.vue")
  },
  {
    name: "setup",
    path: "/setup",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/setup/index.vue")
  },
  {
    name: "style",
    path: "/style",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/style/index.vue")
  },
  {
    name: "alerts",
    path: "/alerts",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/alerts/index.vue")
  },
  {
    name: "bionic",
    path: "/bionic",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/bionic/index.vue")
  },
  {
    name: "bulk-receipt",
    path: "/bulk/receipt",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/bulk/receipt.vue")
  },
  {
    name: "form-designer",
    path: "/form-designer",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/form-designer.vue")
  },
  {
    name: "insights-logs",
    path: "/insights/logs",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/insights/logs.vue")
  },
  {
    name: "internal-logo",
    path: "/internal/logo",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/internal/logo.vue")
  },
  {
    name: "internal-vue3",
    path: "/internal/vue3",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/internal/vue3.vue")
  },
  {
    name: "settings-data",
    path: "/settings/data",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/settings/data.vue")
  },
  {
    name: "bionic-bionic2",
    path: "/bionic/bionic2",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/bionic/bionic2.vue")
  },
  {
    name: "bionic-bionic3",
    path: "/bionic/bionic3",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/bionic/bionic3.vue")
  },
  {
    name: "bionic-bionic4",
    path: "/bionic/bionic4",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/bionic/bionic4.vue")
  },
  {
    name: "internal",
    path: "/internal",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/internal/index.vue")
  },
  {
    name: "page-not-found",
    path: "/page-not-found",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/page-not-found.vue")
  },
  {
    name: "approvals",
    path: "/approvals",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/approvals/index.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/dashboard/index.vue")
  },
  {
    name: "reporting",
    path: "/reporting",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/reporting/index.vue")
  },
  {
    name: "setup-partner",
    path: "/setup/:partner()",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/setup/[partner].vue")
  },
  {
    name: "blueprints",
    path: "/blueprints",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/blueprints/index.vue")
  },
  {
    name: "insights-crawler",
    path: "/insights/crawler",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/insights/crawler.vue")
  },
  {
    name: "internal-ai-help",
    path: "/internal/ai-help",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/internal/ai-help.vue")
  },
  {
    name: "internal-sandbox",
    path: "/internal/sandbox",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/internal/sandbox.vue")
  },
  {
    name: "settings-fluency",
    path: "/settings/fluency",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/settings/fluency.vue")
  },
  {
    name: "blueprints-config",
    path: "/blueprints/config",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/blueprints/config.vue")
  },
  {
    name: "insights-feedback",
    path: "/insights/feedback",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/insights/feedback.vue")
  },
  {
    name: "internal-api-test",
    path: "/internal/api-test",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/internal/api-test.vue")
  },
  {
    name: "prospecting",
    path: "/prospecting",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/prospecting/index.vue")
  },
  {
    name: "reporting-billing",
    path: "/reporting/billing",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/reporting/billing.vue")
  },
  {
    name: "reporting-history",
    path: "/reporting/history",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/reporting/history.vue")
  },
  {
    name: "reporting-preview",
    path: "/reporting/preview",
    meta: previewKVGNJl7R7sM4We8Gvtt9T_ru18vLcuulvTxmz5rCBf8Meta || {},
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/reporting/preview.vue")
  },
  {
    name: "settings-customer",
    path: "/settings/customer",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/settings/customer.vue")
  },
  {
    name: "customer-broadcast",
    path: "/customer/broadcast",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/customer/broadcast.vue")
  },
  {
    name: "internal-prime-vue",
    path: "/internal/prime-vue",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/internal/prime-vue.vue")
  },
  {
    name: "account-crawlerData",
    path: "/account/crawlerData",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/account/crawlerData.vue")
  },
  {
    name: "internal-adRenderer",
    path: "/internal/adRenderer",
    meta: adRendererUgpUUvuI1360UhQq1rfnbhpqpqvAmIitG6K9r_45VfP3gMeta || {},
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/internal/adRenderer.vue")
  },
  {
    name: "internal-colab-test",
    path: "/internal/colab-test",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/internal/colab-test.vue")
  },
  {
    name: "internal-smoke-test",
    path: "/internal/smoke-test",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/internal/smoke-test.vue")
  },
  {
    name: "internal-chartRender",
    path: "/internal/chartRender",
    meta: chartRenderhh8O21vVQu9SqyQeNe7ixI_45wKGwJXPwk18_45XEn33b8kMeta || {},
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/internal/chartRender.vue")
  },
  {
    name: "internal-drag-n-drop",
    path: "/internal/drag-n-drop",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/internal/drag-n-drop.vue")
  },
  {
    name: "internal-settings-v2",
    path: "/internal/settings-v2",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/internal/settings-v2.vue")
  },
  {
    name: "internal-style-guide",
    path: "/internal/style-guide",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/internal/style-guide.vue")
  },
  {
    name: "settings-target-sets",
    path: "/settings/target-sets",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/settings/target-sets.vue")
  },
  {
    name: "blueprints-tag-review",
    path: "/blueprints/tag-review",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/blueprints/tag-review.vue")
  },
  {
    name: "insights-reverse-sync",
    path: "/insights/reverse-sync",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/insights/reverse-sync.vue")
  },
  {
    name: "internal-dynamic-form",
    path: "/internal/dynamic-form",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/internal/dynamic-form.vue")
  },
  {
    name: "alerts-anomalies",
    path: "/alerts/anomalies",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/alerts/anomalies/index.vue")
  },
  {
    name: "insights-budget-groups",
    path: "/insights/budget-groups",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/insights/budget-groups.vue")
  },
  {
    name: "insights-peer-insights",
    path: "/insights/peer-insights",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/insights/peer-insights.vue")
  },
  {
    name: "internal-colab-manager",
    path: "/internal/colab-manager",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/internal/colab-manager.vue")
  },
  {
    name: "insights-change-history",
    path: "/insights/change-history",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/insights/change-history.vue")
  },
  {
    name: "internal-blueprint-demo",
    path: "/internal/blueprint-demo",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/internal/blueprint-demo.vue")
  },
  {
    name: "internal-dynamic-report",
    path: "/internal/dynamic-report",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/internal/dynamic-report.vue")
  },
  {
    name: "internal-layout-builder",
    path: "/internal/layout-builder",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/internal/layout-builder.vue")
  },
  {
    name: "reporting-data-explorer",
    path: "/reporting/data-explorer",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/reporting/data-explorer.vue")
  },
  {
    name: "settings-account-ingest",
    path: "/settings/account-ingest",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/settings/account-ingest.vue")
  },
  {
    name: "dashboard-example-widget",
    path: "/dashboard/example-widget",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/dashboard/example-widget.vue")
  },
  {
    name: "internal-customers",
    path: "/internal/customers",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/internal/customers/index.vue")
  },
  {
    name: "settings-shared-audiences",
    path: "/settings/shared-audiences",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/settings/shared-audiences.vue")
  },
  {
    name: "insights-analyst-scorecard",
    path: "/insights/analyst-scorecard",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/insights/analyst-scorecard.vue")
  },
  {
    name: "internal-engineering-audit",
    path: "/internal/engineering-audit",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/internal/engineering-audit.vue"),
    children: [
  {
    name: "internal-engineering-audit-engineeringAuditProjectSummary",
    path: "engineeringAuditProjectSummary",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/internal/engineering-audit/engineeringAuditProjectSummary.vue")
  },
  {
    name: "internal-engineering-audit-engineeringAuditCustomerBreakdown",
    path: "engineeringAuditCustomerBreakdown",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/internal/engineering-audit/engineeringAuditCustomerBreakdown.vue")
  }
]
  },
  {
    name: "settings-crawlSiteDetector",
    path: "/settings/crawlSiteDetector",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/settings/crawlSiteDetector.vue")
  },
  {
    name: "account-crawlerDebugBrowser",
    path: "/account/crawlerDebugBrowser",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/account/crawlerDebugBrowser.vue")
  },
  {
    name: "insights-budget-adjustments",
    path: "/insights/budget-adjustments",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/insights/budget-adjustments.vue")
  },
  {
    name: "insights-account-performance",
    path: "/insights/account-performance",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/insights/account-performance.vue")
  },
  {
    name: "insights-partner-sync-status",
    path: "/insights/partner-sync-status",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/insights/partner-sync-status.vue")
  },
  {
    name: "internal-blueprint-tag-language",
    path: "/internal/blueprint-tag-language",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/internal/blueprint-tag-language.vue")
  },
  {
    name: "insights-keyword-recommendations",
    path: "/insights/keyword-recommendations",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/insights/keyword-recommendations.vue")
  },
  {
    name: "settings-customerPackageSelector",
    path: "/settings/customerPackageSelector",
    component: () => import("/home/production/git/fluent-ui/apps/backpack/src/pages/settings/customerPackageSelector.vue")
  },
  {
    name: component_45stub6MOtWOnrm951L4QaSPbSZthkl00hz7jYr6s9QFjblg4Meta?.name,
    path: "/setup/start",
    component: component_45stub6MOtWOnrm951L4QaSPbSZthkl00hz7jYr6s9QFjblg4
  },
  {
    name: component_45stub6MOtWOnrm951L4QaSPbSZthkl00hz7jYr6s9QFjblg4Meta?.name,
    path: "/setup/connect",
    component: component_45stub6MOtWOnrm951L4QaSPbSZthkl00hz7jYr6s9QFjblg4
  },
  {
    name: component_45stub6MOtWOnrm951L4QaSPbSZthkl00hz7jYr6s9QFjblg4Meta?.name,
    path: "/setup/csv",
    component: component_45stub6MOtWOnrm951L4QaSPbSZthkl00hz7jYr6s9QFjblg4
  }
]